module.exports = "https://dev.stanwinstonschool.com/swsca-logo-white.0932135cc0f3e34691dedad0e690d98a.svg";